import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { AUTH_DIALOG_TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, AUTH_DIALOG_TRANSLATION_KEY, {
  AUTH_DIALOG_MOBILE_HEADER_TITLE: 'Join today',
  AUTH_DIALOG_MOBILE_HEADER_SUBTITLE: 'Experience the best creative and digital learning experience.',
  AUTH_DIALOG_MOBILE_HEADER_TITLE_PROMO: 'You are one step away from starting!',
  AUTH_DIALOG_MOBILE_HEADER_SUBTITLE_PROMO: "Sign up and access Crehana's free courses",
  // Aside
  YOU_ARE_ABOUT_TO_START: 'You are about to start',
  GET: 'Get',
  FREE: ' free ',
  COURSES_AND_RESOURCES: 'access to courses, Lives, downloadable resources, and much more.',
  // Switcher
  REGISTER_TITLE: 'Join today',
  REGISTER_SUBTITLE: 'Be part of the new generation of digital professionals.',
  LOGIN_TITLE: 'Welcome Back',
  LOGIN_MODAL_SUBTITLE: 'Log in to continue learning',
  LOGIN_REGISTER_CONTINUE: 'or continue with',
  LOGIN_REGISTER_CONTINUE_2: 'Or create an account with',
  REGISTER: 'Sign up',
  LOGIN_NOT_MEMBER: 'Not a member yet?',
  REGISTER_NOT_MEMBER: 'Already have an account?',
  LOGIN_REGISTER: 'Sign up',
  REGISTER_LOGIN: 'Log in',
  // SignIn
  AUTH_VALIDATION_USER_LENGTH: 'The username field must be between 6 and 75 characters',
  AUTH_VALIDATION_PASSWORD_LENGTH: 'Your password must be between 6 and 20 characters',
  LOGIN_EMAIL: 'Username or Email',
  AUTH_VALIDATION_REQUIRED: 'Required field',
  LOGIN_PASSWORD: 'Password',
  LOGIN_FORGET_PASSWORD: 'Forgot your password?',
  LOGIN_MAIN_BUTTON: 'Log in',
  // SignUp
  REGISTER_EMAIL: 'Email',
  AUTH_VALIDATION_EMAIL_IN_USE: 'The entered email is already in use',
  AUTH_VALIDATION_VALID_EMAIL: 'Enter a valid email address',
  AUTH_VALIDATION_LEGALS_REQUIRED: 'You must accept the Terms, Conditions, and Policies to continue.',
  REGISTER_FIRST_NAME: 'First Name',
  REGISTER_LASTNAME: 'Last Name',
  // Affiliate aside
  AFFILIATE_REGISTER_TITLE_PART_A: 'Sign up and Earn\n',
  AFFILIATE_REGISTER_TITLE_PART_B: 'up to 20% of the purchase amount.',
  AFFILIATE_LOGIN_TITLE: 'Join today',
  AFFILIATE_LOGIN_SUBTITLE: 'Be part of the new generation of digital professionals.'
});